import { filterCapitalize } from "@/filters/capitalize";
import SelectItem from "@/models/components/inputs/selectItem";
import i18n from "@/plugins/i18n";

export enum COST_HINT_TYPE {
  ServiceVATMargin = 1,
  SubstantiveDescription = 2,
}

export const costHintTypeSelect = [
  { text: filterCapitalize(i18n.t("serviceVATMargin")), value: COST_HINT_TYPE.ServiceVATMargin },
  { text: filterCapitalize(i18n.t("substantiveDescription")), value: COST_HINT_TYPE.SubstantiveDescription },
] as Array<SelectItem>;
